<svg-icon *ngIf="name" [key]="name" [width]="width" [height]="height"></svg-icon>
